export enum SidebarTypes {
    UNSPLASH = 'UNSPLASH',
    COURSESIDEBAR = 'COURSESIDEBAR'
}
